var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4689 22.75H9.05377C5.21435 22.75 3.00537 20.65 3.00537 17V7C3.00537 3.35 5.21435 1.25 9.05377 1.25H17.4689C21.3084 1.25 23.5173 3.35 23.5173 7V17C23.5173 20.65 21.3084 22.75 17.4689 22.75ZM9.05377 2.75C6.04535 2.75 4.58322 4.14 4.58322 7V17C4.58322 19.86 6.04535 21.25 9.05377 21.25H17.4689C20.4774 21.25 21.9395 19.86 21.9395 17V7C21.9395 4.14 20.4774 2.75 17.4689 2.75H9.05377Z",
    fill: "#4F5B92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0988 9.25H17.995C16.3961 9.25 15.1023 8.02 15.1023 6.5V4.5C15.1023 4.09 15.4599 3.75 15.8912 3.75C16.3225 3.75 16.6801 4.09 16.6801 4.5V6.5C16.6801 7.19 17.2692 7.75 17.995 7.75H20.0988C20.5301 7.75 20.8877 8.09 20.8877 8.5C20.8877 8.91 20.5301 9.25 20.0988 9.25Z",
    fill: "#4F5B92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2614 13.75H9.05381C8.62254 13.75 8.26489 13.41 8.26489 13C8.26489 12.59 8.62254 12.25 9.05381 12.25H13.2614C13.6927 12.25 14.0503 12.59 14.0503 13C14.0503 13.41 13.6927 13.75 13.2614 13.75Z",
    fill: "#4F5B92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.469 17.75H9.05381C8.62254 17.75 8.26489 17.41 8.26489 17C8.26489 16.59 8.62254 16.25 9.05381 16.25H17.469C17.9003 16.25 18.2579 16.59 18.2579 17C18.2579 17.41 17.9003 17.75 17.469 17.75Z",
    fill: "#4F5B92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.b25e2a0021181df5f73c8956d7c49327.svg";
export { ForwardRef as ReactComponent };